<template>
  <vx-card>
    <template>
      <div class="vx-row">
        <div class="vx-col w-full">
          <h6 class="mb-2">Cliente</h6>
          <vs-input
            name="cliente"
            v-validate="'required'"
            class="w-full"
            disabled
            :value="data.fantasia || data.nome">
          </vs-input>
          <!-- <span class="text-danger text-sm" v-show="errors.has('cliente')">{{ errors.first('cliente') }}</span> -->
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <h6 class="mb-2">Tipo de Cobrança</h6>
          <v-select
            disabled
            name="tipoCobranca"
            v-validate="'required'"
            :options="tipoCobrancaOptions"
            v-model="data.tipoCobranca">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
          <!-- <span class="text-danger text-sm" v-show="errors.has('tipoCobranca')">{{ errors.first('tipoCobranca') }}</span> -->
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <template v-if="data.tipoCobranca">
            <div v-if="data.tipoCobranca == 'Boleto'">
              <h6 class="mb-2">Condição de Pagamento</h6>
              <vs-input disabled name="boleto" v-validate="'required'" v-mask="'###/###/###/###/###/###/###'" class="w-full" key="boleto" v-model="data.opcaoBoleto" />
              <!-- <span class="text-danger text-sm" v-show="errors.has('boleto')">{{ errors.first('boleto') }}</span> -->
            </div>
            <div v-else-if="data.tipoCobranca == 'Cartão de Crédito'">
              <h6 class="mb-2">Número de Parcelas (máx. 6x)</h6>
              <vs-input disabled name="cartaoCredito" v-validate="'required'" type="number" v-mask="cartaoCreditoMask" class="w-full" key="cartaoCredito" v-model="data.opcaoCredito" />
              <!-- <span class="text-danger text-sm" v-show="errors.has('cartaoCredito')">{{ errors.first('cartaoCredito') }}</span> -->
            </div>
            <div v-else>
              <h6 class="mb-2">Nenhuma opção disponível</h6>
              <vs-input class="w-full" disabled />
            </div>
          </template>
          <div v-else>
            <h6 class="mb-2">Nenhuma opção disponível</h6>
            <vs-input class="w-full" disabled />
          </div>
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Transportadora (ou digite quem irá recolher)</h6>
          <v-select
            name="transportadora"
            label="nomeCurto"
            v-validate="'required'"
            v-model="data.transportadora"
            taggable
            disabled
            :options="getCarriers"
            :create-option="uppercase">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
          <!-- <span class="text-danger text-sm" v-show="errors.has('transportadora')">{{ errors.first('transportadora') }}</span> -->
        </div>
        <div class="vx-col md:w-1/6 w-full">
          <h6 class="mb-2">Volume</h6>
          <vs-input name="volume" type="number" v-validate="'required'" v-mask="'######'" class="w-full" v-model="data.volume" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Valor do Frete</h6>
          <vs-input name="valorFrete" v-validate="'required'" ref="valorFrete" v-currency="currencyMaskOptions" class="w-full" v-model="data.valorFrete" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Tipo</h6>
          <v-select
            name="tipoFrete"
            v-validate="'required'"
            v-model="data.tipoFrete"
            :options="tipoFreteOptions">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
          <!-- <span class="text-danger text-sm" v-show="errors.has('tipoFrete')">{{ errors.first('tipoFrete') }}</span> -->
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col w-full">
          <h6 class="mb-2">Observações</h6>
          <vs-textarea class="w-full" v-model="data.observacoes" v-uppercase />
        </div>
      </div>
    </template>
    <br>
    <template>
      <EditPurchaseOrderSidebar
        type="editPurchaseOrder"
        :isSidebarActive="editPurchaseOrderSidebar"
        @productEdited="productEdited"
        @closeSidebar="toggleDataSidebar"
        :data="{products: getProducts, productToEdit: getProductToEdit}" />
      <h4 class="mb-5">Produtos</h4>
      <!-- <div class="flex flex-wrap-reverse items-center">
        <div @click="addNewData" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
          <feather-icon
            icon="PlusIcon"
            svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Novo</span>
        </div>
      </div> -->
      <vs-table ref="table" :max-items="1000" :noDataText="'Nenhum produto adicionado'" :data="addedProducts">
        <template slot="thead">
          <vs-th>Descrição</vs-th>
          <vs-th>Marca</vs-th>
          <vs-th>Modelo</vs-th>
          <vs-th>Quantidade</vs-th>
          <vs-th>Valor Unit.</vs-th>
          <vs-th>Valor Total</vs-th>
          <vs-th>Ações</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="addedProducts" :key="indextr" v-for="(product, indextr) in data">
              <vs-td>
                <p class="font-medium">{{ product.descricaoPTBR }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.marca }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.modelo }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.quantidade }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.valorUnitario }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.valorTotal }}</p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(product)" />
                <!-- <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteData(product)" /> -->
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <!-- <div v-if="!(addedProducts).length">
        <vs-input name="jsonProdutos" v-model="jsonProdutosToValidate" v-validate="'required'" class="hidden w-full"></vs-input>
        <span class="text-danger text-sm" v-show="errors.has('jsonProdutos')">{{ errors.first('jsonProdutos') }}</span>
      </div> -->
    </template>
    <div class="flex flex-wrap items-center" slot="footer">
      <vs-button class="mr-6" @click="submitData()">Salvar</vs-button>
    </div>
  </vx-card>
</template>
<script>
import helpers from "@/helpers"
import axios from "axios"
import { baseApiUrl } from "@/global"
import { Validator } from 'vee-validate';
import EditPurchaseOrderSidebar from "./NewPurchaseOrderSidebar.vue";
import { setValue } from 'vue-currency-input'

// const dict = {
//   custom: {
//     tipoCobranca: { required: 'Selecione um tipo de cobrança' },
//     boleto: { required: 'Insira a condição de pagamento' },
//     cartaoCredito: { required: 'Insira a quantidade de parcelas' },
//     transportadora: { required: 'Selecione a transportadora' },
//     jsonProdutos: { required: 'Selecione ao menos 1 produto' },
//   }
// };

// Validator.localize('en', dict);


export default {
  data() {
    return {
      idPurchaseOrder: null,
      data: {},
      products: [],
      productToEdit: null,
      addedProducts: [],
      jsonProdutosToValidate: null,
      helpers: null,
      cartaoCreditoMask: {
        mask: '6',
        tokens: {
          '6': {
            pattern: /[1-6]/,
          }
        }
      },
      currencyMaskOptions: helpers.maskOptions.currency,
      editPurchaseOrderSidebar: false,
      tipoCobrancaOptions: ["Boleto", "À Vista", "Cartão de Crédito"],
      tipoFreteOptions: ["CIF", "FOB"],
      uppercase: (label) => (label.toUpperCase())
    }
  },
  directives: helpers.directives,
  components: {
    EditPurchaseOrderSidebar,
  },
  computed: {
    getCustomers() {
      return this.$store.state.customers
    },
    getProducts() {
      return this.$store.state.products
    },
    getCarriers() {
      return this.$store.state.carriers
    },
    getProductToEdit() {
      return this.productToEdit
    },
  },
  methods: {
    editData(data) {
      this.productToEdit = data
      this.toggleDataSidebar(true);
    },
    deleteData(data) {
      this.addedProducts = this.addedProducts.filter(el => !(el == data))
    },
    toggleDataSidebar(val = false) {
      this.editPurchaseOrderSidebar = val;
    },
    productEdited() {
      this.productToEdit = null
    },
    addProductToTable(productData) {
      this.addedProducts.push(productData)
    },
    async loadPurchaseOrder() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/purchaseOrders/${this.idPurchaseOrder}`);
        this.data = response.data
        this.addedProducts = JSON.parse(response.data.jsonProdutos)
        this.data.transportadora = this.data.nomeCurto || this.data.nomeRetirar

        if (this.data.tipoCobranca == 'Boleto')
          this.data.opcaoBoleto = this.data.opcaoPagamento
        if (this.data.tipoCobranca == 'Cartão de Crédito')
          this.data.opcaoCredito = this.data.opcaoPagamento

        for (const addedProduct of this.addedProducts) {
          addedProduct.valorUnitario = this.helpers.moneyHelper.formatNumberToCurrency(addedProduct.valorUnitario, 'R$')
          addedProduct.valorTotal = this.helpers.moneyHelper.formatNumberToCurrency(addedProduct.valorTotal, 'R$')
        }

        if (this.data.valorFrete)
          setValue(this.$refs.valorFrete.$refs.vsinput, this.data.valorFrete)

      } catch (error) {
        if (error.response && error.response.status != 400)
          this.$router.push({ name: 'purchaseOrder-list' })
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async submitData() {
      if (this.data.tipoCobranca == 'Boleto')
        delete this.data.opcaoCredito
      if (this.data.tipoCobranca == 'Cartão de Crédito')
        delete this.data.opcaoBoleto

      for (let addedProduct of this.addedProducts) {
        addedProduct.valorUnitario = this.$parseCurrency(addedProduct.valorUnitario, this.currencyMaskOptions)
        addedProduct.valorTotal = this.$parseCurrency(addedProduct.valorTotal, this.currencyMaskOptions)
      }

      const formData = {
        modificadoEm: this.helpers.dateHelper.getDateTimeToSql(),
        modificadoPor: this.$store.state.user.idUser,
        observacoes: this.data.observacoes || '-',
        valorFrete: this.$parseCurrency(this.data.valorFrete, this.currencyMaskOptions),
        tipoFrete: this.data.tipoFrete,
        volume: this.data.volume,
        jsonProdutos: JSON.stringify(this.addedProducts)
      }

      try {
        this.$vs.loading()
        await axios.put(`${baseApiUrl}/purchaseOrders/${this.idPurchaseOrder}`, formData)
        this.$router.push({ name: 'purchaseOrder-list' })

      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar: " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  async created() {
    this.idPurchaseOrder = this.$route.params.idPurchaseOrder
    this.helpers = helpers
    const payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch("fetchProductsItems", payload)
    await this.$store.dispatch("fetchCarriersItems", payload)
    await this.loadPurchaseOrder()
  }
}

</script>
